import { IMenuItem } from 'models/IMenuItem';
import cn from 'classnames';
import styles from './styles.scss';
import { CategoryItem } from './categoryItem';
import { MenuItem } from './menuItem';
import { Grid, Cell } from 'components/Grid';
import { useMenuToggle } from 'components/MainMenu/useMenuToggle';
import { useEffect } from 'react';
import { selectBlackFridayStatus } from 'components/Header/themes/BGH/selector';
import { useSelector } from 'react-redux';

interface OwnProps extends Pick<IMenuItem, 'subCategories'> {
  isParentOpen: boolean;
  isLoading: boolean;
}
export const CategoryContainer = ({ isParentOpen, isLoading, subCategories }: OwnProps) => {
  const [openId, openMenu, closeMenu, setOpen] = useMenuToggle<IMenuItem['id'] | undefined>(
    isParentOpen,
    isLoading
  );
  const blackFridayIsActive = useSelector(selectBlackFridayStatus);

  useEffect(() => {
    if (!isParentOpen) {
      setOpen(undefined);
    }
  }, [openId, isParentOpen, setOpen]);

  return (
    <div
      className={cn(styles.category, styles.container, {
        [styles.open]: isParentOpen,
        [styles.blackFriday]: blackFridayIsActive
      })}
    >
      <ul
        className={cn(styles.categories, {
          [styles.open]: isParentOpen
        })}
      >
        {subCategories.map(sc => (
          <CategoryItem
            key={sc.id}
            {...{
              ...sc,
              openMenu: openMenu(sc.id),
              closeMenu,
              isOpen: sc.id === openId,
              isLoading
            }}
          />
        ))}
      </ul>
      <div className={styles.wrapper} onMouseOver={openMenu(openId)}>
        {openId && (
          <Grid huge="4" phone="3" gutters="extraLarge">
            {(subCategories.find(sc => sc.id === openId) || subCategories[0]).subCategories.map(
              sc => (
                <Cell key={sc.id}>
                  <MenuItem key={sc.id} {...sc} />
                </Cell>
              )
            )}
          </Grid>
        )}
      </div>
    </div>
  );
};
